export default {
  模板内容提示:
    'Notice: The texts on the templates are for reference only. Users may use or reuse templates downloaded on this website. Copyrights and other related rights of the templates in this website are owned by Cloud Exhibition.',
  展台面积: 'Total Area',
  展厅高度: 'Height',
  灯光要求: 'Lighting Requirements',
  文件大小: 'File Size',
  开口方向: 'Booth Opening',
  展台长宽: 'Length and Width',
  材质贴图: 'Metal,Anisotropic',
  软件版本: 'Version',
  模型类型: 'Type of Designs',
  下载需: 'Download Requires',
  金币: ' Coins',
  立即下载: 'Download Now',
  模型作者: 'Designer',
  云展动力签约模型师: 'Signed Designer of Cloud Exhibition',
  余额不足提示: 'Notice: Insufficient funds. Please top up.',
  立即充值: 'Top up Now',
  模型购买: 'Purchase Design',
  账户余额: 'Account Balance',
  总价: 'Grand Total',
  立即购买: 'Buy Now',
  取消: 'Cancel',
  价格: 'Price',
  模型购买成功提示: 'Congratulations! Purchase successful!',
  模型购买成功说明: 'You can view your purchase history in My Account>My Purchases, or you can download it again.',
  暂不下载: 'Download Later',
  操作余额不足提示: 'Sorry, insufficient funds. Please top up.',
}
